import React from "react"
import { connect } from "react-redux"
import { getFormValues } from "redux-form"
import "components/style.scss"
import { FORM_NAMES } from "constants/index"
import PhoneArea from "components/PhonePreview/PhoneArea"

const PushNotificationPreview = ({ notificationValues = {} }) => {
  return (
    <PhoneArea style={{ paddingLeft: "0px", paddingBottom: "0px" }}>
      <div
        style={{
          backgroundImage: `url("https://admin.dev.markedprivate.com/app/images/preview/lock-screen.jpg")`,
          width: "105%",
          height: "105%",
          backgroundSize: "cover",
          marginLeft: "-5px",
        }}
      >
        <div className="push-notification ">
          <div className="title ">{notificationValues?.subject}</div>
          <div className="message">{notificationValues?.message}</div>
        </div>
      </div>
    </PhoneArea>
  )
}

const mapStateToProps = state => ({
  notificationValues: getFormValues(FORM_NAMES.NOTIFICATION)(state),
})

export default connect(mapStateToProps)(PushNotificationPreview)
